/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletGroupIcon24Solid = forwardRef('TextBulletGroupIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2 4.5A1.5 1.5 0 0 1 3.5 3h4A1.5 1.5 0 0 1 9 4.5v4A1.5 1.5 0 0 1 7.5 10h-4A1.5 1.5 0 0 1 2 8.5v-4Z" }),
        React.createElement("path", { d: "M12.25 3.25a1.25 1.25 0 1 0 0 2.5h8.5a1.25 1.25 0 1 0 0-2.5h-8.5Z" }),
        React.createElement("path", { d: "M11 9.5c0-.69.56-1.25 1.25-1.25h8.5a1.25 1.25 0 1 1 0 2.5h-8.5c-.69 0-1.25-.56-1.25-1.25Z" }),
        React.createElement("path", { d: "M12.25 13.25a1.25 1.25 0 1 0 0 2.5h8.5a1.25 1.25 0 1 0 0-2.5h-8.5Z" }),
        React.createElement("path", { d: "M12.25 18.25a1.25 1.25 0 1 0 0 2.5h8.5a1.25 1.25 0 1 0 0-2.5h-8.5Z" }),
        React.createElement("path", { d: "M3.5 14A1.5 1.5 0 0 0 2 15.5v4A1.5 1.5 0 0 0 3.5 21h4A1.5 1.5 0 0 0 9 19.5v-4A1.5 1.5 0 0 0 7.5 14h-4Z" })));
});
